import type { PreferencesSet } from '@risksmart-app/shared/knock/schemas';
import type { UpdateNotificationPreferencesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

type UpdateNotificationPreferencesInput = { preferenceSet: PreferencesSet };

const mapTrpcResponseToGraphQL = (): UpdateNotificationPreferencesMutation => ({
  updateNotificationPreferences: {
    __typename: 'UpdateNotificationPreferencesOutput',
    message: 'Preferences updated',
  },
});

export const useUpdateNotificationPreferencesTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...trpc.frontend.notifications.userPreferences.set.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.notifications.userPreferences.get.queryKey(),
        });
      },
    }),
  });

  return {
    updateNotificationPreferences: async (
      variables: UpdateNotificationPreferencesInput
    ): Promise<UpdateNotificationPreferencesMutation> => {
      await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL();
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
